import { SocialLinkRow } from "@/components/social/SocialLinkRow";

/**
 * `social_links` block — a placeable "Listen / Follow" section. Renders its own
 * curated `content.links` map (e.g. only streaming services above the fold),
 * independent of the site-wide header/footer links.
 */
export function SocialLinksBlock({ content }: { content: Record<string, unknown> }) {
  const heading = content.heading ? String(content.heading) : "";
  const links =
    content.links && typeof content.links === "object"
      ? (content.links as Record<string, string>)
      : {};

  if (Object.keys(links).length === 0) return null;

  return (
    <section className="mx-auto max-w-6xl px-4 py-8">
      {heading && (
        <h2 className="mb-4 text-xl font-semibold text-[var(--color-text)]">{heading}</h2>
      )}
      <SocialLinkRow links={links} variant="block" />
    </section>
  );
}
